'use client';

// Third Party
import * as React from 'react';
import Image from 'next/image';

// Utils
import { routes } from '@routes';
import { GRAY_PIXEL_DATA_URL } from '@utils/constants';
import { Props } from '.';
import { imagekitLoader } from '@utils/imagekit-loader';

// UI
import { Typography } from '@components/typography';

export const FeaturedDestinationGridSection: React.FC<Props> = ({
  destinations,
}) => {
  if (!destinations || destinations.length < 2) return null;

  return (
    <div className="hidden lg:block">
      <div className="max-w-7xl mx-auto px-8">
        <div className="mb-10">
          <Typography
            component="h2"
            variant="title3"
            className="text-primary-main !text-3xl sm:!text-4xl lg:!text-[2.5rem]"
          >
            Popular destinations
          </Typography>
        </div>

        <div className="grid grid-cols-4 gap-5">
          {destinations.slice(0, 4).map((destination) => (
            <a
              key={destination.placeId}
              href={routes.searchShow({
                placeId: destination.placeId || '',
              })}
              className="group relative w-full h-[400px] rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300"
              rel="nofollow"
            >
              <Image
                src={destination.imageUrl || ''}
                alt={destination.name || ''}
                fill
                className="object-cover transition-transform duration-500 group-hover:scale-110"
                placeholder="blur"
                blurDataURL={GRAY_PIXEL_DATA_URL}
                sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 25vw"
                loader={imagekitLoader}
              />
              {/* Enhanced gradient overlay for better text legibility */}
              <div className="absolute inset-0 bg-gradient-to-t from-primary-main/70 via-primary-main/20 to-transparent" />

              {/* Enhanced typography with explore prompt */}
              <div className="absolute bottom-6 left-6 right-6">
                <Typography
                  component="h3"
                  variant="title5"
                  className="text-white drop-shadow-lg !text-2xl"
                >
                  {destination.name}
                </Typography>
                <p className="text-white/80 text-sm font-light mt-1 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  Explore stays →
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};
